import { AppConfig } from '@/types/env';

// 環境変数の安全な取得（React用）
const getEnvVar = (key: string, defaultValue: string = ''): string => {
  return process.env[key] || defaultValue;
};

// 環境変数からアプリケーション設定を構築
export const config: AppConfig = {
  apiUrl: getEnvVar('REACT_APP_API_BASE_URL', 'http://localhost'),
  stripePublishableKey: getEnvVar('REACT_APP_STRIPE_PUBLISHABLE_KEY'),
  environment: getEnvVar('REACT_APP_ENV', 'development'),
  version: getEnvVar('REACT_APP_VERSION', '1.0.0'),
  isDebug: getEnvVar('REACT_APP_DEBUG') === 'true',
};

// 環境チェック用のヘルパー関数
export const isDevelopment = () => config.environment === 'development';
export const isProduction = () => config.environment === 'production';
export const isStaging = () => config.environment === 'staging'; 